// extracted by mini-css-extract-plugin
module.exports = {"title":"Sobre_title__3hVNx","description":"Sobre_description__33QL0"};